import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-browser-not-supported',
  templateUrl: './browser-not-supported.component.html',
  styleUrls: ['./browser-not-supported.component.scss']
})
export class BrowserNotSupportedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
